<template>
  <loading-data-page-container :loading="loading" :loading-error="loadingError" :loading-error-message="loadingErrorMsg" class="bestand--page">

    <v-container v-if="!loading && !loadingError" class="pa-0" fluid>

      <div class="semanticsection-title2 primary--text">Bestandsverträge</div>

      <div v-if="isVertriebsleiter">
        <select-vmnr @vmnr-change="loadBestand"></select-vmnr>
      </div>

      <table-container @excel="exportExcel"
                       @reset-filters="resetSingleFilter">
        <!--- full search ----------------------------------------------------------------------------->
        <v-text-field slot="full-search"
                      v-model="search"
                      label="Nach Vertrag suchen"
                      append-icon="search"
                      single-line
                      hide-details
                      clearable />
        <!--- detail filters ----------------------------------------------------------------------------->
        <v-row slot="detail-filters"
                  no-gutters
                  class="detail--filters">
          <v-col cols="12"
                 sm="6"
                 md="4">
            <!--- Status filter --------------------------------------------------------------------------->
            <v-select v-model="singleFilters.Status"
                      :items="statusOptions"
                      hide-details
                      label="Status"
                      @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <!--- Vertragsnummer filter ---------------------------------------------------------->
            <v-text-field v-model="singleFilters.Vertragsnummer"
                          clearable
                          hide-details
                          label="Vertragsnummer"
                          @input="applySingleFilter" />
          </v-col>
          <!--- Beginn filter ----------------------------------------------------------------------------->
          <v-col cols="12"
                 sm="6"
                 md="4">
            <date-field v-model="singleFilters.Beginn.von"
                        v-validate="'date_format:DD.MM.YYYY'"
                        hide-details
                        clearable
                        label="Beginn von"
                        @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <date-field v-model="singleFilters.Beginn.bis"
                        v-validate="'date_format:DD.MM.YYYY'"
                        hide-details
                        clearable
                        label="Beginn bis"
                        @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <!--- Name filter ----------------------------------------------------------------------------->
            <v-text-field v-model="singleFilters.Name"
                          clearable
                          hide-details
                          label="Name"
                          @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <!--- Produkt filter ----------------------------------------------------------------------------->
            <v-text-field v-model="singleFilters.Produkt"
                          clearable
                          hide-details
                          label="Produkt"
                          @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <!--- Versicherungsumfang filter ----------------------------------------------------------------------------->
            <v-text-field v-model="singleFilters.Versicherungsumfang"
                          clearable
                          hide-details
                          label="Versicherungsumfang"
                          @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <!--- Jahresprämie filter ----------------------------------------------------------------------------->
            <v-select v-model="singleFilters.Jahrespraemie.mode"
                      :items="[ {text: '=', value: 0}, {text: '<', value: -1}, {text: '>', value: 1} ]"
                      hide-details
                      label="Jahresprämie brutto"
                      @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <v-text-field v-model="singleFilters.Jahrespraemie.value"
                          clearable
                          hide-details
                          label="Betrag Jahresprämie brutto"
                          @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <!--- Schäden filter ----------------------------------------------------------------------------->
            <v-select v-model="singleFilters.Schaeden.mode"
                      :items="[ {text: '=', value: 0}, {text: '<', value: -1}, {text: '>', value: 1} ]"
                      hide-details
                      label="Schäden"
                      @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <v-text-field v-model.number="singleFilters.Schaeden.value"
                          clearable
                          hide-details
                          label="Anzahl Schäden"
                          @input="applySingleFilter" />
          </v-col>
          <v-col cols="12"
                 sm="6"
                 md="4">
            <!--- Mahnstatus filter ----------------------------------------------------------------------------->
            <v-select v-model="singleFilters.Mahnstatus"
                      :items="mahnstatusOptions"
                      hide-details
                      label="Mahnstatus"
                      @input="applySingleFilter" />
          </v-col>
        </v-row>

        <bestand-table ref="bestandTable"
                       :bestand="filteredBestand"
                       :search="search"
                       @show-details="showDetails"
                       @edit-contract="editContract"
                       @excel="exportExcel"
                       @show-damages="showDamages" />

      </table-container>

    </v-container>

  </loading-data-page-container>

</template>
<script>
import dummyData from "@/store/dummyData/bestandDummyData";
import DateField from "@/components/DateField";
import LoadingDataPageContainer from "@/components/kundenverwaltung/LoadingDataPageContainer";
import TableContainer from "@/components/kundenverwaltung/TableContainer";
import BestandTable from "@/components/kundenverwaltung/BestandTable";
import SelectVmnr from "@/components/kundenverwaltung/SelectVmnr";
import httpService from '@/helper/httpService';
import ExcelMixin from '@/pages/kundenverwaltung/ExcelMixin';
import TableDataMixin from '@/pages/kundenverwaltung/TableDataMixin';
import ParsingMixin from '@/pages/kundenverwaltung/ParsingMixin';

import {STATUS_VALUES, MAHNSTATUS_VALUES} from "@/components/kundenverwaltung/valueLists";
import { CONNECTION_ERROR_MESSAGE } from "@/helper/httpService";
import ValidationMixin from '../../components/helper/ValidationMixin';
import { RIGHTS } from '../../store/user';

export default {
  components: {
    LoadingDataPageContainer, BestandTable, TableContainer, DateField, SelectVmnr
  },
  mixins: [ExcelMixin, TableDataMixin, ParsingMixin, ValidationMixin],
  data() {
    return {
      loading: true,
      loadingError: false,
      loadingErrorMsg: '',
      bestand: [],
      formattedBestand: [],
      filteredBestand: [],
      singleFilters: this.getInitalFilterState(),
      search: '',
      vertriebsleiterVmnr: ''
    };
  },
  computed: {
    statusOptions: function () {
      const options = STATUS_VALUES.filter((status) => {
        return this.bestand.find(item => item.Status === status);
      });
      options.push({ text: 'alle', value: '' });
      return options;
    },
    mahnstatusOptions: function () {
      const options = MAHNSTATUS_VALUES.filter((status) => {
        return this.bestand.find(item => item.Mahnstatus === status);
      });
      options.push({ text: 'alle', value: '' });
      return options;
    },
    isVertriebsleiter: function () {
      return this.$store.getters.checkAuthorization(RIGHTS.VERTRIEBSLEITER);
    }
  },
  created() {
    this.loadBestand(null);
  },
  methods: {
    loadBestand: function (vmnr) {
      if (vmnr) this.vertriebsleiterVmnr = vmnr;
      httpService.getBestand(vmnr)
        .then(bestand => {
          this.bestand = bestand;
          this.formattedBestand = bestand.map(this.formatData);
          this.filteredBestand = [].concat(this.formattedBestand);
          this.loading = false;
        })
        .catch(err => {
          console.log(`GET CONTRACTS failed with ${err.status}: ${err.message}`);
          //TODO delete dummy data for production
          if (this.$store.state.env.environment === 'development' && err.status !== 403) {
            this.bestand = dummyData;
            this.formattedBestand = dummyData.map(this.formatData);
            this.filteredBestand = [].concat(this.formattedBestand);
            this.loading = false;
          } else {
            this.loadingErrorMsg = err.status < 500 ? 'Keine Verträge gefunden' : CONNECTION_ERROR_MESSAGE;
            this.loadingError = true;
            this.loading = false;
          }
        });
    },
    formatData: function (bestandItem) {
      const produktInformation = this.deriveProduktInformation(bestandItem);
      return {
        Status: this.$helpers.statusFix( bestandItem.Status, bestandItem.Ende),
        Vertragsnummer: bestandItem.Vertragsnummer,
        Name: `${bestandItem.Name}, ${bestandItem.Vorname}`,
        Beginn: this.$helpers.dateToTime(bestandItem.Beginn),
        Produkt: produktInformation.produkt,
        Versicherungsumfang: produktInformation.umfang,
        // prepend string length for sort order to sort by length first; works because length is < 10 in all cases
        sortableVersicherungsumfang: produktInformation.umfang.length + produktInformation.umfang,
        Jahrespraemie: bestandItem.Beitrag,
        Schaeden: +bestandItem.Schaeden,
        SchaedenOffen: +bestandItem.SchaedenOffen,
        Mahnstatus: bestandItem.Mahnstatus,
        allowEdit: this.allowEditVertrag(bestandItem)
      };
    },
    getInitalFilterState() {
      return {
        'Status': '',
        'Vertragsnummer': '',
        'Beginn': {
          von: '',
          bis: ''
        },
        'Name': '',
        'Produkt': '',
        'Versicherungsumfang': '',
        'Jahrespraemie': {
          mode: 0,
          value: ''
        },
        'Schaeden': {
          mode: 0,
          value: ''
        },
        'Mahnstatus': ''
      };
    },

    showDetails: function (data) {
      let route = {
        name: this.vertriebsleiterVmnr ? 'VLBestandDetailPage' : 'BestandDetailPage',
        params: {
          vertragsnummer: data.vertragsnummer,
          vmnr: this.vertriebsleiterVmnr,
          data: this.bestand.filter(v => v.Vertragsnummer === data.vertragsnummer)[0],
          backTo: 'BestandDetailPage'
        }
      };
      if (data.newTab) {
        let routeData = this.$router.resolve(route);
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push(route);
      }
    },
    editContract: function (vertragsnummer) {
      this.$store.dispatch('resetAenderungsData');
      let route = {
        name: 'AenderungsantragPage',
        params: {
          vertragsnummer: vertragsnummer,
          vertrag: this.bestand.filter(v => v.Vertragsnummer === vertragsnummer)[0],
          backTo: 'AenderungsantragPage'
        }
      };
      this.$router.push(route);
    },
    showDamages(vertragsnummer, newPage) {
      const target = {
        name: this.vertriebsleiterVmnr ? 'VLSchadenDetailPage' : 'SchadenDetailPage',
        params: {
          vertragsnummer,
          vmnr: this.vertriebsleiterVmnr,
          backTo: 'Bestand'
        }
      };
      if (newPage === true) {
        const routeData = this.$router.resolve(target);
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push(target);
      }
    },
    exportExcel: function (vertragsnummer) {
      if (!vertragsnummer) {
        this.generateExcel([].concat(this.bestand.map(this.formatBestandDataForExcel)), this.columnFormatBestandDataForExcel(), "Gesamter_Bestand");
      } else {
        this.generateExcel(this.bestand.filter(v => v.Vertragsnummer === vertragsnummer).map(this.formatBestandDataForExcel), this.columnFormatBestandDataForExcel(), "Vertr-Nr-" + vertragsnummer);
      }
    },
    //filters in detail search
    applySingleFilter: function () {
      this.filteredBestand = this.formattedBestand.filter(row => {
        //apply custom filter on Schäden and Beginn
        if (this.singleFilters.Schaeden.value !== ''
          && !this.filterCompare(row.Schaeden, this.singleFilters.Schaeden.value, this.singleFilters.Schaeden.mode)) {
          return false;
        }
        if (this.singleFilters.Jahrespraemie.value !== ''
          && !this.filterCompare(row.Jahrespraemie, this.formatDecimal(this.singleFilters.Jahrespraemie.value), this.singleFilters.Jahrespraemie.mode)) {
          return false;
        }
        if ((this.singleFilters.Beginn.von || this.singleFilters.Beginn.bis)
          && !this.filterDateBetween(row.Beginn, this.singleFilters.Beginn.von, this.singleFilters.Beginn.bis)) {
          return false;
        }
        //apply standard filter for remaining header line filters
        const vals = ['Status', 'Vertragsnummer', 'Name', 'Produkt', 'Versicherungsumfang', 'Mahnstatus'];
        for (let i = 0; i < vals.length; i++) {
          const columnName = vals[i];
          if (this.singleFilters[columnName] && !this.filterDefault(row[columnName], this.singleFilters[columnName])) {
            return false;
          }
        }
        return true;
      });
    },
    resetSingleFilter: function () {
      this.singleFilters = this.getInitalFilterState();
      this.applySingleFilter();
    }
  }
};
</script>
<style>

.bestand--page .v-input:not(.v-input--selection-controls) {
  max-width: 344px;
}

.bestand--page .detail--filters div[class*=col-] {
  display: flex;
  justify-content: center;
  padding: 0 20px;
}

</style>
